import { BufferGeometry } from "three";
import { MeshBVH } from "three-mesh-bvh";
import { GenerateMeshBVHWorker } from "./GenerateMeshBVHWorker";

export type IBvhCallback = (bvh: MeshBVH, geo: BufferGeometry) => unknown;
type ITaskData = {geo: BufferGeometry, id: string};


export class BVHWorkerController extends GenerateMeshBVHWorker {
    private _taskQueue: ITaskData[] = [];
    private _onGenerationCbs: {[id:string]: IBvhCallback} = {};

    tick() {
        if (!this._taskQueue.length || this.isRunning) return;
        const {geo, id} = this._taskQueue[0];
        this._generate(id, geo);
        this._taskQueue.shift();
    }

    private _generate(id: string, geo: BufferGeometry) {
        const geoClone = geo.clone();
        this.generate(geoClone).then((bvh: MeshBVH) => {
            geoClone.dispose();
            this._onGenerationCbs[id]?.(bvh, geo)
        });
    }

    onBvhGeneration(id: string, cb: IBvhCallback) {
        this._onGenerationCbs[id] = cb;
    }

    bvhGeneration(geo: BufferGeometry, id: string, useQueue = true) {
        if (!useQueue && !this.running) {
            this._generate(id, geo);
            return;
        }

        const existingTaskData = this._taskQueue.filter(d => d.id === id)[0] as ITaskData | undefined;

        if (existingTaskData) {
            existingTaskData.geo = geo;
            return;
        }
        this._taskQueue.push({geo, id});
    }
    
    public get isRunning() : boolean {
        return this.running;
    }
    
}
